export default __webpack_public_path__ + "static/media/cult-logo-white SVG.39ebdabb.svg";